// src/App/jsx
import React from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Dashboard from './components/Dashboard/Dashboard'
import LessonWizard from './components/Wizard/LessonWizard'
import LessonDesignView from './components/LessonDesign/LessonDesignView'
import AuthForm from './components/Auth/AuthForm'
import StimulusDetail from './components/Stimuli/StimulusDetail'
import PedagogyLibrary from './components/Pedagogy/PedagogyLibrary'

// Debug component to show auth state
const DebugAuth = () => {
  const { user, loading, initialized } = useAuth()
  
  if (process.env.NODE_ENV !== 'development') {
    return null
  }
  
  return (
    <div className="fixed top-4 right-4 p-4 bg-white border border-gray-300 rounded shadow-lg z-50 text-xs opacity-75 hover:opacity-100 pointer-events-none">
      <div>Loading: {loading ? 'true' : 'false'}</div>
      <div>Initialized: {initialized ? 'true' : 'false'}</div>
      <div>User: {user ? user.email : 'null'}</div>
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <DebugAuth />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/pedagogy" element=
          {<ProtectedRoute><PedagogyLibrary /></ProtectedRoute>}/>
          <Route path="/lesson/new" element={<ProtectedRoute><LessonWizard /></ProtectedRoute>} />
          <Route path="/lesson/:id" element={<ProtectedRoute><LessonDesignView /></ProtectedRoute>} />
          <Route path="/stimulus/:id" element={<StimulusDetail />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App